import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { inject, observer } from 'mobx-react';
import styled from '@emotion/styled';
import { PharmacyAnnualReview } from '../../store/models/PharmacyAnnualReview';
import { InputGroup } from '@blueprintjs/core';
import { Form } from 'react-final-form';
import { PharmacyAnnualReviewSearchCriteria } from '../../store/PharmacyAnnualReviewStore';
import { PharmacyStore, PharmacyStatusStore } from '../../store';
import {
  DataGrid,
  Column,
  Button as DGButton,
  Sorting,
  SearchPanel,
  DataGridTypes,
  Export,
  FilterRow,
  FilterPanel,
  HeaderFilter,
  GroupPanel,
  Grouping,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { PharmacyStatusCell } from '../common/grid/PharmacyStatusCell';
interface PrefManagerProps extends WithTranslateProps {
  pharmacyList: any;
  searchCriteria: Instance<typeof PharmacyAnnualReviewSearchCriteria>;
  onSearch: (criteria: any) => void;
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
  filter: string;
  setFilterText: (filter: string) => void;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  PharmacyStatusStore?: Instance<typeof PharmacyStatusStore>;
}

interface PrefManagerState {
  annualReviewEdition?: Instance<typeof PharmacyAnnualReview>;
  annualReviewIsLoading?: boolean;
  secretariatId?: number;
  year?: number;
  width?: number;
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  padding-bottom: 5px;
`;

@inject('PharmacyStore')
@inject('PharmacyStatusStore')
@observer
class PrefManager extends React.Component<PrefManagerProps, PrefManagerState> {
  state = {
    systemStatusEdition: undefined,
    annualReviewIsLoading: false,
    secretariatId: 1,
    year: 0,
    width: 90,
  } as PrefManagerState;

  buildGridData = () => {
    const { activeFilter } = this.props;
    return this.props.pharmacyList
      .filter((elem) => {
        let show = true;
        if (activeFilter === 'three' && (elem.level == null || elem.level !== 3)) {
          show = false;
        } else if (activeFilter === 'one' && (elem.level == null || elem.level !== 1)) {
          show = false;
        }
        return show;
      })
      .map((p) => ({
        pharmacyId: p.pharmacyId,
        level: p.level,
        apbNumber: p.apbNumber,
        name: p.name,
        prefDutyDayOff: p.prefDutyDayOff,
        prefDutyDayOn: p.prefDutyDayOn,
        statusId: p.statusId,
        statusName: p.statusId ? this.getPharmacyStatus(p.statusId!)!.name : ''
      }));
  };

  handleCalculate = () => { };

  onChangeYear = (data) => {
    this.setState({ year: data });
  };

  onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Pharmacy_Prefs.xlsx');
      });
    });
  };

  displayPharmacyStatusCell = (params: any) => {
    var pharmacyStatusId = params.row.data.statusId;
    if (pharmacyStatusId === undefined) return <></>;

    const pharmacyStatus = this.getPharmacyStatus(pharmacyStatusId);
    if (pharmacyStatus === undefined) return <></>;

    return <PharmacyStatusCell pharmacyStatus={pharmacyStatus} />;
  };

  getPharmacyStatus = (statusId: number) => {
    return this.props.PharmacyStatusStore!.dataList.find(
      (ps) => ps.pharmacyStatusId === statusId,
    );
  }

  render() {
    const { setFilterText, filter, translate } = this.props;
    return (
      <Container>
        <Form onSubmit={this.props.onSearch} initialValues={this.props.searchCriteria}>
          {({ }) => (
            <div>
              <DivLine>
                <DivLeft>
                  <InputGroup
                    placeholder="Filter..."
                    leftIcon="search"
                    value={filter}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </DivLeft>
              </DivLine>
            </div>
          )}
        </Form>

        <DataGrid id="prefDayOffList"
          dataSource={this.buildGridData()}
          showBorders
          allowColumnResizing
          onExporting={this.onExporting}
          width={'100%'}
        >
          <Export enabled={true} texts={{ exportAll: translate(TLCode.GRID_EXCEL_EXPORT) }} />
          <Sorting mode="multiple" />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <FilterRow visible={true} applyFilter={'auto'} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} width={400} />
          <Grouping autoExpandAll={false} />            <Column dataType="string" dataField="level" />
          <Column dataType="string" dataField="apbNumber" />
          <Column dataType="string" dataField="name" />
          <Column dataType="string" dataField="prefDutyDayOff" width={100} />
          <Column dataType="string" dataField="prefDutyDayOn" width={100} />
          <Column
            cellRender={this.displayPharmacyStatusCell}
            dataField="statusName"
            caption={translate(TLCode.PHARMACY_Status)} />
          <Pager
            visible={true}
            allowedPageSizes={[5, 10, 20, 50, 100]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />
          <Paging defaultPageSize={20} />
        </DataGrid>
      </Container>
    );
  }
}

export default withTranslate(PrefManager);
